export const COMPANY_TYPE_OPTIONS = [
  { value: "architecte", label: "Architecte" },
  { value: "bureau_d_etudes", label: "Bureau d'études" },
  { value: "bureau_de_controle", label: "Bureau de contrôle" },
  { value: "electricite", label: "Électricité" },
  { value: "photovoltaique", label: "Photovoltaïque" },
  { value: "plomberie", label: "Plomberie" },
  { value: "menuiserie", label: "Menuiserie" },
  { value: "cuisine", label: "Cuisine" },
  { value: "escalier", label: "Escalier" },
  { value: "charpente", label: "Charpente" },
  { value: "gros_oeuvre", label: "Gros œuvre" },
  { value: "assainissement", label: "Assainissement" },
  { value: "couverture", label: "Couverture" },
  { value: "etancheite", label: "Étanchéité" },
  { value: "gouttieres", label: "Gouttières" },
  { value: "enduit", label: "Enduit" },
  { value: "ravalement", label: "Ravalement" },
  { value: "chape", label: "Chape" },
  { value: "isolation", label: "Isolation" },
  { value: "cloisonnement", label: "Cloisonnement" },
  { value: "carrelage", label: "Carrelage" },
  { value: "peinture", label: "Peinture" },
  { value: "parquet", label: "Parquet" },
  { value: "nettoyage", label: "Nettoyage" },
  { value: "assurance", label: "Assurance" },
  { value: "huissier", label: "Huissier" },
  { value: "traitement_termite", label: "Traitement termite" },
  { value: "autre_btp", label: "Autre BTP" },
  { value: "autre", label: "Autre" },
];

export const COMPANY_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  COMPANY_TYPE_OPTIONS.map((o) => [o.value, o.label]),
);
